import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const FloatingSection = {
	$section: null,

	init: function() {
		this.$section = document.querySelector('.js-floating-section');
		if (!this.$section) return;
		this.animateImages();
		this.animateLogo();
	},

	animateImages: function() {
		const items = this.$section.querySelectorAll('.floating-section__item');

		items.forEach(item => {
			const img = item.querySelector('img');

			gsap.from(img, {
				rotateX: -75,
				transformOrigin: '50% 100%',
				ease: 'power2.out',
				scrollTrigger: {
					trigger: item,
					start: 'top 90%',
					end: 'top 30%',
					scrub: 1,
				},
			});
		});
	},

	animateLogo: function() {
		const logoSticky = this.$section.querySelector('.floating-section__logo-sticky');
		if (!logoSticky) return;

		ScrollTrigger.create({
			trigger: logoSticky,
			start: () => `top ${window.innerHeight / 2 - 70}px`,
			onEnter: () => logoSticky.classList.add('is-sticky'),
			onLeaveBack: () => logoSticky.classList.remove('is-sticky'),
		});

		gsap.to(logoSticky, {
			opacity: 0,
			ease: 'none',
			scrollTrigger: {
				trigger: this.$section,
				start: 'center center',
				end: 'bottom center',
				scrub: 1,
			},
		});
	},
};

export default FloatingSection;
